import { capitalizeFirstLetter } from "@sscs/utils";
export const SERVICE_TYPE_TO_TEXT = {
    "chat-exchange": "Chat exchange",
    "code-processor": "Code processor",
    "code-provider": "Code provider",
    "data-exchange": "Data exchange",
    "data-forwarder": "Data forwarder",
    "data-generic": "Data generic",
    "data-provider": "Data provider",
    "data-processor": "Data processor",
    "file-exchange": "File exchange",
    "mail-exchange": "Mail exchange",
    "push-provider": "Push provider",
    "user-finance": "User finance",
    "user-identity": "User identity",
    "user-location": "User location",
    "user-tracking": "User tracking",
    "voip-provider": "VoIP provider",
};
export const ML_APPROACH_TO_TEXT = {
    "reinforcement-learning": "Reinforcement learning",
    "self-supervised": "Self-Supervised",
    "semi-supervised": "Semi-Supervised",
    supervised: "Supervised",
    undeclared: "Undeclared",
    unsupervised: "Unsupervised",
};
export const transformMaterialType = (materialType) => materialType
    .split("-")
    .map((item) => capitalizeFirstLetter(item))
    .join(" ");
//# sourceMappingURL=xbom.js.map